import { PaymentType } from 'types';

import { createCrudApi } from './crud.api';

export const paymentTypesApi = createCrudApi<PaymentType>('/payment-types');
